<template>
  <div class="all-content">
    <!-- 顶部推荐 -->
    <div class="title">
      <div class="first-game">
        <video
          :src="state.outiquelists.videourl"
          :poster="state.outiquelists.pic3"
          class="videobox"
          webkit-playsinline="true"
          x5-video-player-type="h5-page"
          x5-video-player-fullscreen="true"
          controlslist="nodownload nofullscreen noremoteplayback"
          disablePictureInPicture="true"
          playsinline="true"
          ref="videoPlayer"
          controls
        ></video>
        <p>
          <img src="../../assets/game/icon_free_welfare.png" alt="" />
          <span> {{ state.outiquelists.label }}</span>
        </p>
        <div class="title-info" @click="goGamedetails(state.outiquelists.id)">
          <img :src="state.outiquelists.pic1" alt="" />
          <div class="title-game-info">
            <p>{{ state.outiquelists.gamename }}</p>
            <p>
              {{ state.outiquelists.typeword }}
              {{ state.outiquelists.gamesize }}
            </p>
          </div>
          <span
            class="title-tag"
            :class="state.outiquelists.is_boutique ? 'boutique' : ''"
          >
            {{ handleDiscount(state.outiquelists.firstpay) }}折
          </span>
        </div>
      </div>
    </div>
    <!-- 瀑布流 -->
    <div class="section_top">
      <li
        v-for="(item, index) in state.freeGameList1"
        :key="index + item.id"
        @click="goGamedetails(item.id)"
      >
        <!-- {{ item.gamename }} -->
        <img :src="item.pic3" alt="" v-if="index == 6" />
        <p v-if="index % 3 == 0 || index == 1 || index == 5">
          <img src="../../assets/game/icon_free_welfare01.png" alt="" />
          <span> {{ item.welfare }}</span>
        </p>
        <div class="section-game">
          <img :src="item.pic1" alt="" />
          <div class="section-game-info">
            <h4>{{ item.gamename }}</h4>
            <p>
              <span>{{ handleDiscount(item.firstpay) }}折</span>
              <span>{{ item.typeword }}</span>
            </p>
          </div>
        </div>
      </li>
    </div>
    <!-- 中间 近期热门好游-->
    <div class="center">
      <div>
        <p>
          <span>更多</span>
          <img src="../../assets/game/icon_free_more.png" alt="" />
        </p>
        <ul>
          <li
            v-for="(item, index) in state.lasthotgame"
            :key="index + item.id"
            @click="goGamedetails(item.id)"
          >
            <img :src="item.pic3" alt="" />
            <h4>{{ item.gamename }}</h4>
            <p>
              <span>{{ handleDiscount(item.firstpay) }}折</span>
              <span>{{ item.typeword }}</span>
            </p>
            <button>下载</button>
          </li>
        </ul>
        <p @click="exchangeGame">
          <span>换一换</span>
          <img src="../../assets/game/icon_free_exchange.png" alt="" />
        </p>
      </div>
    </div>
    <!-- 底部 -->
    <ul class="bottom">
      <li
        v-for="(item, index) in state.freeGameList2"
        :key="index + item.id"
        @click="goGamedetails(item.id)"
      >
        <img :src="item.pic1" alt="" />
        <div class="info">
          <h4>{{ item.gamename }}</h4>
          <p>
            <span>{{ item.typeword }}</span>
            <span>{{ item.gamesize }}</span>
          </p>
          <p v-if="!item.label">
            {{ item.welfare }}
          </p>
          <p v-else class="safe_play">
            <img src="../../assets/homepage/icon_hotwelfare_tag.png" alt="" />
            {{ item.label }}
          </p>
          <span
            class="tag"
            :class="state.outiquelists.is_boutique ? 'boutique' : ''"
            >{{ handleDiscount(item.firstpay) }}折</span
          >
        </div>
      </li>
    </ul>
  </div>
</template>
<script setup>
import { onMounted, reactive } from "vue";
import { getFreeGame, getFreeGameChange } from "@/api/yzgame";
import { handleDiscount } from "@/utils/tool";

const state = reactive({
  freeGameList: [],
  freeGameList1: [],
  freeGameList2: [],
  lasthotgame: [],
  outiquelists: {},
});

onMounted(() => {
  freeGame();
});

const freeGame = async () => {
  let res = await getFreeGame({
    type: "ios",
  });
  if (res.data.code == 1) {
    state.freeGameList = res.data.data.freegamelist.list;
    state.lasthotgame = res.data.data.lasthotgame.list;
    state.outiquelists = res.data.data.outiquelists.list[0];

    state.freeGameList1 = state.freeGameList.slice(0, 7);
    state.freeGameList2 = state.freeGameList.slice(7, 10);
  }

};

const exchangeGame = async () => {
  let res = await getFreeGameChange({ anniu: 1 });

  if (res.data.code == 1) {
    state.lasthotgame = res.data.data.list;
  }
};

import { detect } from "@/utils/device"; // 跳转到游戏详情页
const goGamedetails = (gid) => {
  if (detect() == "android" || detect() == "harmony") {
    window.document.location = "gogame://" + gid;
  } else {
    var eventData = {
      eventType: "openEvent",
      gid: gid,
    };
    window.parent.postMessage(eventData, "*");
  }
  // console.log("跳转到游戏详情页--------", gid);
};
</script>
<style scoped>
.all-content {
  background-color: #f7f8fa;
  height: 100vh;
  overflow: auto;
  padding-bottom: 150px;
}
.title,
.section_top,
.center,
.bottom {
  padding: 0 32px;
}
.title {
  width: 100%;
  background-image: url(../../assets/game/icon_free_bg.png);
  background-size: contain;
  padding-top: 250px;
  background-repeat: no-repeat;
}
.title .first-game {
  height: 610px;
  width: 100%;
  background: linear-gradient(136deg, #21e5d2 0%, #00d166 100%);
  border-radius: 24px;
  padding: 24px;
}
.title .first-game > p {
  height: 50px;
  font-size: 20px;
  color: #fff;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  font-weight: 600;
  padding-left: 24px;
  display: flex;
  align-items: center;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.3) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  border-radius: 10px;
  margin: 12px 0 16px 0;
}
.title .first-game > p img {
  width: 23px;
  height: 23px;
  vertical-align: sub;
  margin-right: 10px;
}
.title .first-game video {
  width: 100%;
  height: 356px;
  border-radius: 16px;
  object-fit: cover;
}
.title .title-info {
  display: flex;
  align-items: center;
  position: relative;
}
.title .title-info img {
  width: 128px;
  height: 128px;
  border-radius: 35px;
}
.title .title-info .title-game-info {
  color: #fff;
  margin-left: 20px;
}
.title .title-info .title-game-info p:nth-of-type(1) {
  font-size: 32px;
  font-weight: 600;
}
.title .title-info .title-game-info p:nth-of-type(2) {
  font-size: 24px;
  margin-top: 8px;
}
.title .title-info .title-tag {
  position: absolute;
  right: 24px;
  display: flex;
  width: 100px;
  height: 44px;
  border-radius: 198px;
  background-color: #fff;
  font-size: 28px;
  font-weight: 600;
  color: #00d9c3;
  align-items: center;
  justify-content: center;
}
.title .title-info .boutique {
  width: 132px;
  height: 64px;
  color: #fff;
  background: url(../../assets/game/icon_free_discountbg.png);
  background-size: 100% 100%;
  padding-bottom: 18px;
  right: 0;
  top: 32px;
}

/* 中间瀑布流区域 */
.section_top {
  margin: 24px 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-height: 1000px;
  align-content: space-between;
}
.section_top li {
  width: 334px;
  /* min-height: 150px; */
  /* max-height: 398px; */
  background-color: #fff;
  border-radius: 20px;
  margin-bottom: 14px;
}
.section_top li > img {
  width: 334px;
  height: 204px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.section_top li p {
  font-size: 20px;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.section_top li > p {
  padding: 24px 24px 0;
  font-size: 24px;
  color: #333;
  display: flex;
  align-items: center;
}
.section_top li > p > img {
  height: 24px;
  width: 24px;
  margin-right: 4px;
}
.section_top li > p span {
  width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.section_top li .section-game {
  display: flex;
  align-items: center;
  padding: 24px;
}
.section_top li .section-game img {
  width: 110px;
  height: 110px;
  border-radius: 24px;
  margin-right: 20px;
}
.section_top li .section-game p:nth-of-type(1) {
  font-size: 24px;
  text-wrap: wrap;
}

.section_top .section-game-info h4 {
  font-size: 24px;
  font-weight: 600;
}

.section_top li .section-game .section-game-info p {
  font-size: 20px;
  color: #999999;
}
.section_top li .section-game .section-game-info p span:nth-of-type(1) {
  color: #00d9c3;
  font-weight: 600;
  margin-right: 4px;
}

/* 中间近期好游 */
.center {
  width: 100%;
  height: 1018px;
  margin-bottom: 24px;
}
.center > div {
  height: 100%;
  background-color: #fff;
  padding: 16px 22px 40px;
  border-radius: 24px;
  background: url(../../assets/game/icon_free_centerBg.png);
  background-size: 100% 100%;
}
.center > div > p {
  color: #999999;
  font-size: 24px;
  display: flex;
  align-items: center;
}
.center > div > p:nth-of-type(1) {
  justify-content: flex-end;
  margin-bottom: 40px;
}
.center > div > p:nth-of-type(1) img {
  width: 28px;
  height: 28px;
}
.center > div > p:nth-of-type(2) {
  width: 638px;
  height: 78px;
  background-color: #f4f5f8;
  border-radius: 20px;
  justify-content: center;
  margin-top: 6px;
}
.center > div > p > img {
  width: 24px;
  height: 24px;
  margin-left: 8px;
}
.center > div ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.center > div ul li {
  width: 310px;
  height: 386px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 24px;
  margin-bottom: 20px;
}
.center > div ul li:nth-of-type(1) {
  background-color: #f0f2ff;
}
.center > div ul li:nth-of-type(2) {
  background-color: #fffcf2;
}
.center > div ul li:nth-of-type(3) {
  background-color: #e9faff;
}
.center > div ul li:nth-of-type(4) {
  background-color: #eefff8;
}
.center > div ul li img {
  width: 310px;
  height: 202px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.center > div ul li h4 {
  font-size: 28px;
  margin: 12px 0;
}
.center > div ul li p {
  margin: 0 0 16px;
  display: flex;
  align-items: center;
}
.center > div ul li p span:nth-of-type(1) {
  font-size: 20px;
  color: #00d9c3;
  margin-right: 8px;
  display: inline-block;
  padding: 2px 4px;
  border: 1px solid #00d9c3;
  border-radius: 6px;
}
.center > div ul li p span:nth-of-type(2) {
  font-size: 24px;
  color: #666666;
}
.center > div ul li button {
  width: 100px;
  height: 44px;
  background: #00d9c3;
  border-radius: 100px;
  border: none;
  color: #fff;
}

/* 底部 */

.bottom li {
  margin-bottom: 12px;
  border-radius: 20px;
  background-color: #fff;
  display: flex;
  align-items: center;
  padding: 24px;
  position: relative;
}
.bottom li img {
  width: 144px;
  height: 144px;
  margin-right: 20px;
}
.bottom li h4 {
  font-size: 30px;
  color: #333;
}
.bottom li p {
  font-size: 24px;
  color: #999999;
}
.bottom li p:nth-of-type(1) {
  margin: 10px 0;
}

.bottom li p:nth-of-type(2) {
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bottom li .tag {
  position: absolute;
  top: 74px;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 44px;
  background: #00d9c3;
  color: #fff;
  border-radius: 198px;
}
.bottom li .boutique {
  background: url(../../assets/game/icon_free_discountbg01.png);
  width: 132px;
  height: 64px;
  background-size: 100% 100%;
  color: #00d9c3;
  padding-bottom: 15px;
  font-weight: 600;
}

.safe_play {
  display: inline-flex;
  align-items: center;
}
.bottom li .safe_play img {
  height: 30px;
  width: auto;
  margin: 0 2px 0 0;
  vertical-align: middle;
}
.bottom li .info .safe_play {
  height: 32px;
  font-size: 21px;
  line-height: 34px;
  border-radius: 4px;
  padding: 0 8px 0 4px;
  background-image: url("../../assets/homepage/icon_hotwelfare_tag_back.png");
  background-size: 100% 50%;
  background-repeat: no-repeat;
  background-position: bottom;
  margin-left: 8px;
  font-weight: 700;
  border: 0;
  color: #f99a11;
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
